/*Recurso: Configurations - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetSummaryProponentUser
    GetSummaryUserNotificationbyEmail
    UpdateProponentUser
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const configurationsStore = create((set:any, get:any) => ({
  
  objErrorConfigurationsStore: { hasError: false, url: '', body:'',  recurso:"configurations", componente:'', idresul: 0, desresul:'', menu:'' }, //se llena con la información del api si éste tiene error
    
  //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
    limpiaObjErrorConfigurationsStore: () => {
      let paso = { hasError: false, url:'', body:'', recurso:'configurations', componente:'', idresul:0, desresul:'', menu:''}
      set( { objErrorConfigurationsStore: paso } );
      //console.log('limpiaObjErrorConfigurationsStore (sale) - objErrorConfigurationsStore: ', get().objErrorConfigurationsStore);
    },
                
     //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorConfigurationsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
      //console.log('*generaObjErrorConfigurationsStore (entra): ', responseAPI);
      //console.log('*generaObjErrorConfigurationsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
      let paso = { hasError: h, url:'', body:e, recurso:'configurations', componente:c, idresul:0, desresul:'', menu:m };
      if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
      }
      else if (responseAPI=='Error detectado por api en ret') {
        paso.desresul= h;
        paso.idresul= h2; 
      }
      else {
        let temp = responseAPI.config;
        paso.url = temp.url;
        if (responseAPI.data!="" && responseAPI.data!=null){
          console.log('paso2');
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
        }    
        else {
            paso.idresul= responseAPI.status;
            switch(responseAPI.status){
              //case 404:  paso.desresul= "El usuario no existe"; break;
              case 401:  paso.desresul= "No autorizado"; break;
              case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
              default: paso.desresul= responseAPI.statusText; break;
            }
        }    
      }
      //console.log('paso', paso);
      set( { objErrorConfigurationsStore: paso } );
      console.log('::configurationsStore - generaObjErrorConfigurationsStore (sale) - objErrorConfigurationsStore: ', get().objErrorConfigurationsStore);
    },
    
  panelStore: [ 
    {id:0, abierto:false, texto:'Alta de usuarios proponentes' }, 
    {id:1, abierto:false, texto:'Adicionar usuarios para notificaciones vía correo electrónico' }
  ],  //guarda el panel (menu principal de Configuración), usado para abrir y cerrar panel ventanas y lectura de api

      cierraPanelStore: async () => { //cerramos todos los elementos del panel cada vez que entra en configuración
        //console.log('cierraPanelStore...' )
        get().panelStore.map((pc:any, indexPC:any) => {  pc.abierto = false });
        //console.log ('::::::::::::::::panelStore: ', get().panelStore );
      },

      cambiaPanelStore: async ( idPanel:any) => { 
        //console.log('cambiaPanelStore...' + idPanel)
        get().panelStore.map((pc:any, indexPC:any) => { 
          if (pc.id == idPanel) 
              pc.abierto = ! pc.abierto;
        });
        //console.log ('::::::::::::::::panelStore: ', get().panelStore );
      },

  catalogoPermisosUsuariosStore:[
    { id:0, descripcion:"Con rol RP / RD", activo:true, disabled:true, visible:true},
    { id:1, descripcion:"Rol RP", activo:false, disabled:false, visible:false},
    { id:2, descripcion:"Rol RD", activo:false, disabled:false, visible:false},
    { id:3, descripcion:"Todo el personal de INEGI", activo:false, disabled:false, visible:true},
    { id:4, descripcion:"Personal adscrito a la Dirección General", activo:false, disabled:false, visible:true},
    { id:5, descripcion:"Usuarios específicos", activo:false, disabled:false, visible:true},
  ],

  permisosUsuariosStore:[
    { id:0,  permisos:1,  idCatalogoPermisosUsuario:[1] },
    { id:1,  permisos:2,  idCatalogoPermisosUsuario:[2] },
    { id:2,  permisos:4,  idCatalogoPermisosUsuario:[3] },
    { id:3,  permisos:8,  idCatalogoPermisosUsuario:[4] },
    { id:4,  permisos:16, idCatalogoPermisosUsuario:[5] },
    { id:5,  permisos:3,  idCatalogoPermisosUsuario:[0] },
    { id:6,  permisos:7,  idCatalogoPermisosUsuario:[0,3] },
    { id:7,  permisos:11, idCatalogoPermisosUsuario:[0,4] },
    { id:8,  permisos:19, idCatalogoPermisosUsuario:[0,5] },
    { id:9,  permisos:27, idCatalogoPermisosUsuario:[0,4,5] },
    { id:10, permisos:24, idCatalogoPermisosUsuario:[4,5] }
  ],

  usuariosProponentesStore: [],  //guarda la lista de usuarios proponentes generada por la lectura del api

      //*Tareas: GetSummaryProponentUser  // lista de usuarios proponentes (panel 0)
      guardaGetSummaryProponentUserStore: async (responseAPI:any) => { 
        //console.clear();
        console.log('guardaGetSummaryProponentUserStore - responseAPI:', responseAPI)
        //var _ = require('underscore');

        if (responseAPI.ret==1) { //sin error

            let upPaso =  responseAPI.item ;
            let pasoCatPer:any =[];
            upPaso.map((up:any, indexUP:any) => {
                up.abierto = false; //por omisión entra cerrado 
                up.swUsuariosEspecificos = false;
                //para cargar su propio catálogo de permisos
                    pasoCatPer = JSON.parse(JSON.stringify(get().catalogoPermisosUsuariosStore)); //reinicio arreglo

                  //Con rol RP / RD (id cat:0, permisos b.d.: 3,7,11,19,27,24 )
                    if (up.setting.right_propose==3 || up.setting.right_propose==7 || up.setting.right_propose==11 || up.setting.right_propose==19 || up.setting.right_propose==27 || up.setting.right_propose==24 ) { pasoCatPer[0].activo = true }
                  //Rol RP(id cat:1, permisos b.d.: 1 ) //no entra rp entra Como rol RP/RD
                    if (up.setting.right_propose==1 ) {  pasoCatPer[0].activo = true   }  
                  //Rol RD(id cat:2, permisos b.d.: 2 ) //nunca pasa por aquí rd no configura
                    if (up.setting.right_propose==2 ) {  pasoCatPer[2].activo = true }  
                  //Todo el personal de INEGI (id cat:1, permisos b.d.:4,7 )
                    if ( up.setting.right_propose==4 || up.setting.right_propose==7 ) { pasoCatPer[3].activo = true }
                  //Personal adscrito a la Dirección General (id cat:2, permisos b.d.: 8,11 )
                    if ( up.setting.right_propose==8 || up.setting.right_propose==11 || up.setting.right_propose==24 ) { pasoCatPer[4].activo = true }
                  //Usuarios específicos (id cat:3, permisos b.d.: 16,19,27,24 )
                    if (up.setting.right_propose==16 || up.setting.right_propose==19 || up.setting.right_propose==27 || up.setting.right_propose==24 ) { 
                        pasoCatPer[5].activo = true;
                        up.swUsuariosEspecificos = true;
                    }  
                  up.catPermisos = pasoCatPer;
          
                //hago mayusculas nombre & correo
                  if (up.setting.specificuser.length > 0){
                      up.setting.specificuser.map((su:any, indexSu:any) => { 
                        su.name = su.name.toUpperCase()
                        su.account = su.account.toUpperCase()
                      });
                  }

                up.misUsuEspecificos = up.setting.specificuser;
                up.misUsuEspecificosOrigen =  up.misUsuEspecificos;

                //para traer el estutus  
                  let paso = up.state_process;
                  up.estatusProceso = paso.pt_state_descripcion;
                  up.clasexEstatusIcono = "";
                  switch ( paso.pt_state ) {
                    case 1:  up.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                    case 2:  up.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                    case 3:  up.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                    case 4:  up.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                    default: up.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                  }
                if (up.name=='Todos') { up.id=0; up.name='Todos los procesos a su cargo' } //me aseguro que no tenga null 
            });
            set ( { usuariosProponentesStore: upPaso } );
            console.log('::::::::::usuariosProponentesStore: ', get().usuariosProponentesStore)
            return(get().usuariosProponentesStore);
        }
        else {
            get().generaObjErrorConfigurationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'configurations.store-guardaGetSummaryProponentUserStore')
        }
      },

      //cambia los elementos del catálogo de usuarios autorizados asignado a UsuariosProponentesStore
      //recibe id de UsuarioProponete e id del catálogo Usuarios autorizados (permisos)
      cambiaUsuariosProponentesStore: async ( id:any, idCat:any, objeto:any, dondeViene:any ) => { 
        //console.log('cambiaUsuariosProponentesStore...' , id,  '..' , objeto, '..' , idCat, '..', dondeViene )
       
        switch (dondeViene){
          case 'cambiaCatPermisosUsuarioEspecifico':  
                get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                  if (up.id == id) {
                      up.catPermisos?.map((catP:any, indexCatP:any) => { 
                        if (catP.id == idCat) {
                            catP.activo = false
                            //up.catPermisos[5].activo = false;
                            up.swUsuariosEspecificos = false;
                        }
                      });
                  }
                  
                });

          break;
          case 'cambiaCatPermisos':  
                get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                  if (up.id == id) {
                      up.catPermisos?.map((catP:any, indexCatP:any) => { 
                        if (catP.id == idCat) {
                            catP.activo = !catP.activo;
                            if (catP.id == 3 && catP.activo) {
                                up.catPermisos[4].activo = false;
                                up.catPermisos[5].activo = false;
                            }
                            if (catP.id == 4 && catP.activo) { up.catPermisos[3].activo = false }
                            if (catP.id == 5 && catP.activo) {
                                up.catPermisos[3].activo = false;
                                up.swUsuariosEspecificos = true;
                            }
                            if (catP.id == 5 && catP.activo==false) {
                                ////up.swUsuariosEspecificos = true;
                                up.swUsuariosEspecificos = false;
                            }
                        }
                      });
                  }
                  
                });
          break;
          case 'botonCerrarSinCambios': 
                alert('xxxxidCat'+idCat);
                console.log(':::botonCerrarSinCambios',objeto )
                get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                  if (up.id == id) {
                      up.catPermisos = objeto;
                     // up.misUsuEspecificos = [];
                      up.swUsuariosEspecificos = idCat
                  }
                });
          break;
          case 'botonGuardar':  
               //console.log(':::botonGuardar---------', id , objeto )
                if (id==0) { //hizo cambio por "Todos los procesos a mi cargo hay que agregar a todos"
                    get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                          //console.log('x');
                          up.misUsuEspecificos = objeto;
                    });
                }
                else{
                    get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                      if (up.id == id) {
                          up.misUsuEspecificos = objeto 
                          //if (objeto.length > 0) { }
                      }
                    });
                } 

          break;
          case 'cambiaListaUsuarios':  
                //console.log(':::cambiaListaUsuarios',objeto )
                get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
                    if (up.id == id) {
                        up.setting.specificuser = objeto;
                        up.misUsuEspecificos = objeto;
                    }
                });
          break;
        };
        //console.log (':::get().usuariosProponentesStore: ', get().usuariosProponentesStore );
      },

      canceloUsuarioProponenteStore: async ( id:any, swUsu:any, catPermisosOrigen:any, misUsuariosEspecificosOrigen:any ) => { 
        //console.log('misUsuariosEspecificosOrigen....', misUsuariosEspecificosOrigen)
        //console.log(':::botonCerrarSinCambios')
        get().usuariosProponentesStore.map((up:any, indexUP:any) => { 
          if (up.id == id) {
              up.catPermisos = catPermisosOrigen;
              up.misUsuEspecificos = misUsuariosEspecificosOrigen;
              up.swUsuariosEspecificos = swUsu
          }
        });
      },

      canceloUsuariosNotificiacionesStore: async ( id:any ) => { 
        console.clear();
        console.log('canceloUsuariosNotificiacionesStore....', id)
        //console.log(':::botonCerrarSinCambios')
        get().usuariosNotificacionesStore.map((un:any, indexUN:any) => { 
          if (un.id == id) {
            console.log('pase', un.misNoAceptadas);
              un.rejectprop = un.misNoAceptadas;
              un.okprop = un.misAceptadas;
              un.okanalyse = un.misConcluidas;
              ///un.swUsuariosEspecificos = swUsu
          }
        });
        console.log(':::usuariosNotificacionesStore: ', get().usuariosNotificacionesStore)
      },

  UpdateProponentUserStore:{},

      //*Tarea: UpdateProponentUser
      // entra desde Configuración- Panel 0 (Alta de usuarios proponentes) -  botón: Editar - botón: Guardar - 
      guardaUpdateProponentUserStore: async (responseAPI:any) => {  
        //console.log('guardaUpdateRateProposalStore-responseAPI:',responseAPI)
        if ( responseAPI.ret==1 ) { //inserto sin error
            set( { UpdateProponentUserStore: responseAPI } );
            //console.log('UpdateProponentUserStore:', get().UpdateProponentUserStore);
            return(get().UpdateProponentUserStore);
        }
        else {
           get().generaObjErrorConfigurationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'configurations.store-guardaUpdateProponentUserStore')
        }
      },

  usuariosNotificacionesStore: [],  //guarda la lista de usuarios proponentes generada por la lectura del api

      //*Tareas: GetSummaryUserNotificationbyEmail 
      // lista de usuarios para notificaciones vía correo electrónico (panel 1)
      guardaGetSummaryUserNotificationbyEmailStore: async (responseAPI:any) => {
        //console.log('guardaGetSummaryUserNotificationbyEmailStore - responseAPI:', responseAPI)
        //var _ = require('underscore');
        if (responseAPI.ret==1) { //sin error
          let unPaso =  responseAPI.item ;
          let pasoCatPer:any =[];
          unPaso.map((un:any, indexUN:any) => {
              un.abierto = false; //por omisión entra cerrado 
              //para traer el estutus  
                let paso = un.state_process;
                un.estatusProceso = paso.pt_state_descripcion;
                un.clasexEstatusIcono = "";
                switch ( paso.pt_state ) {
                  case 1:  un.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                  case 2:  un.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                  case 3:  un.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                  case 4:  un.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                  default: un.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                }
              //  
              //ponemos en mayúsculas los datos de usuarios
                if (un.rejectprop.length > 0){
                  //if (un.rejectprop.length > 0){
                    un.rejectprop.map((su:any, indexSu:any) => { 
                      su.name = su.name.toUpperCase()
                      su.account = su.account.toUpperCase()
                    });
                  //}
                };
                un.misNoAceptadas = JSON.parse(JSON.stringify(un.rejectprop));

                if (un.okprop.length > 0){
                    un.okprop.map((su:any, indexSu:any) => { 
                      su.name = su.name.toUpperCase()
                      su.account = su.account.toUpperCase()
                    });
                };
                un.misAceptadas =  JSON.parse(JSON.stringify(un.okprop));

                if (un.okanalyse.length > 0){
                    un.okanalyse.map((su:any, indexSu:any) => { 
                      su.name = su.name.toUpperCase()
                      su.account = su.account.toUpperCase()
                    });
                };
                un.misConcluidas =  JSON.parse(JSON.stringify(un.okanalyse)); ;

              //  
              if (un.name=='Todos') { un.id=0; un.name='Todos los procesos a su cargo' } //me aseguro que no tenga null 
          });
          set ( { usuariosNotificacionesStore: unPaso } );
          console.log(':::usuariosNotificacionesStore: ', get().usuariosNotificacionesStore)
          return(get().usuariosNotificacionesStore);
        }
        else {
            get().generaObjErrorConfigurationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'configurations.store-guardaGetSummaryUserNotificationbyEmailStore')
        }
      },

      cambiaUsuariosNotificacionesStore: async ( id:any, objeto:any, dondeViene:any ) => { 
        //console.log('cambiaUsuariosNotificacionesStore...' , id, '..', dondeViene )
        switch (dondeViene){
          case 'botonGuardar':  
                if (id==0) { //hizo cambio por "Todos los procesos a mi cargo hay que agregar a todos"
                    get().usuariosNotificacionesStore.map((un:any, indexUP:any) => { 
                        un.rejectprop = objeto.rejectprop;
                        un.okprop = objeto.okprop;
                        un.okanalyse = objeto.okanalyse;
                    });
                }
                else{
                    get().usuariosNotificacionesStore.map((un:any, indexUP:any) => { 
                        if (un.id == id) {
                            un.rejectprop = objeto.rejectprop;
                            un.okprop = objeto.okprop;
                            un.okanalyse = objeto.okanalyse;
                        }
                    });
                }
          break;
        };
        //console.log (':::get().usuariosNotificacionesStore: ', get().usuariosNotificacionesStore );
      },

  UpdateUserNotificationbyEmailStore:{},

      //*Tarea: UpdateProponentUser // entra desde Configuración- Panel 1 (Adicionar usuarios para notificaciones vía correo electrónico) -  botón: Editar - botón: Guardar - 
      guardaUpdateUserNotificationbyEmailStore: async (responseAPI:any) => {  
        //console.log('guardaUpdateUserNotificationbyEmailStore-responseAPI:',responseAPI)
        if ( responseAPI.ret==1 ) { //inserto sin error
            set( { UpdateUserNotificationbyEmailStore: responseAPI } );
            //console.log('UpdateUserNotificationbyEmailStore:', get().UpdateUserNotificationbyEmailStore);
            return(get().UpdateUserNotificationbyEmailStore);
        }
        else {
            get().generaObjErrorConfigurationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'configurations.store-guardaUpdateUserNotificationbyEmailStore')
        }
      },      

  
}));

export default configurationsStore;
